import React from "react";
import "./Product.css";
import { Container } from "react-bootstrap";

const Product = () => {
  return (
    <>
      <section className="product-section">
        <Container>
          <div className="top-text-product">
            <h2>
              WHO WE <span> ARE</span>
            </h2>
          </div>
          <h3>
            Codeffi aspires to be one of the leading digital
            <strong class="text-skyblue">Product Development Company</strong>
          </h3>
          <p className="sec-p">
            With over a decade of delivering various IT services to clients
            worldwide, we have conceived a distinctive concept of understanding
            customer behavior. This enables us to create digital products that
            are adored by everyone.
          </p>
          <p>
            Whether you seek to streamline complex business processes or develop
            a unique, complex product within your industry, we have you covered.
            We excel in digitally transforming businesses and turning business
            ideas into realities.
          </p>
          <p className="mb-0">
            We blend cutting-edge technology, captivating user interfaces,
            exceptional business intelligence, unparalleled functional
            robustness, and our extensive business experience across various
            industries. This fusion of expertise allows us to bring substantial
            benefits to our clients and partners. We possess the capacity to
            develop practical solutions capable of addressing any challenge,
            whether simple or complex, faced by your business and/or customers.
          </p>
        </Container>
      </section>
    </>
  );
};

export default Product;
